import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import NumberField from 'components/forms/NumberField'
import { useDispatch } from 'react-redux'
import ToastrAction from 'toastr/actions/ToastrAction'
import { isNil } from 'lodash'


const DialogPopulation = ({
    open= false,
    setOpen= () => {},
    cityCode = -1,

    populations=[],
    setPopulations= () => {},

    defaultValue= {},
    setDefaultValue= () => {},
    isNew= false,
}) => {
    const dispatch = useDispatch()

    const [year, setYear] = useState(isNew ? '' : defaultValue.year)
    const [populationTotalINSEE, setPopulationTotalINSEE] = useState(isNew ? undefined : defaultValue.inseeTotal)
    const [temporaryResident, setTemporaryResident] = useState(isNew ? undefined : defaultValue.temporaryResident)
    const [populationTotalAdjusted, setPopulationTotalAdjusted] = useState(isNew ? undefined : defaultValue.increasedTotal)

    useEffect(() => {
        if (!isNew) {
            setYear(defaultValue.year)
            setPopulationTotalINSEE(defaultValue.inseeTotal)
            setTemporaryResident(defaultValue.temporaryResident)
            setPopulationTotalAdjusted(defaultValue.increasedTotal)
        }
    }, [isNew, defaultValue])

    const resetState = () => {
        setYear()
        setPopulationTotalINSEE()
        setTemporaryResident()
        setPopulationTotalAdjusted()
    }

    const onClose = () => {
        resetState()
        setDefaultValue({})
        setOpen(false)
    }

    const onValidate = () => {
        if (isNil(year)) {
            dispatch(ToastrAction.warning(i18n.pleaseEnterYear))
        } else if (populations.find(popu => popu.year === year) && isNew) {
            dispatch(ToastrAction.warning(i18n.yearSelected))
        } else if (isNew) {
            setPopulations([...populations, {
                cityCode,
                year: parseInt(year),
                inseeTotal: populationTotalINSEE,
                inseeTotalAuto: false,
                temporaryResident,
                temporaryResidentAuto: false,
                increasedTotal: populationTotalAdjusted,
                increasedTotalAuto: false,
            }])
            onClose()
        } else {
            setPopulations(populations.map(popu =>
                popu.year === year
                    ? {
                        cityCode,
                        year: parseInt(year),
                        inseeTotal: populationTotalINSEE,
                        inseeTotalAuto: false,
                        temporaryResident,
                        temporaryResidentAuto: false,
                        increasedTotal: populationTotalAdjusted,
                        increasedTotalAuto: false,
                    }
                    : popu,
            ))
            onClose()
        }
    }

    return (
        <Dialog open={open} maxWidth={'lg'}>
            <DefaultDialogTitle title={isNew ?i18n.addYear : i18n.updateYear} onClose={onClose}/>
            <DialogContent>
                <Grid container spacing={1} margin={1}>
                    <Grid size={3}>
                        <NumberField
                            title={ i18n.year }
                            value={ year }
                            onChange={y => setYear(y) }
                            obligatory
                        />
                    </Grid>
                    <Grid size={3}>
                        <NumberField
                            title={ i18n.totalPopulationINSEE }
                            value={ populationTotalINSEE }
                            onChange={pti => setPopulationTotalINSEE(pti) }
                        />
                    </Grid>
                    <Grid size={3}>
                        <NumberField
                            title={ i18n.temporaryResidents }
                            value={ temporaryResident }
                            onChange={tr => setTemporaryResident(tr) }
                        />
                    </Grid>
                    <Grid size={3}>
                        <NumberField
                            title={ i18n.adjustedTotalPopulation }
                            value={ populationTotalAdjusted }
                            onChange={pta => setPopulationTotalAdjusted(pta) }
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {i18n.close}
                </Button>
                <Button
                    onClick={onValidate}
                    variant='contained'
                    color='primary'
                >
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogPopulation.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    cityCode: PropTypes.number,
    populations: PropTypes.shape({
        cityCode: PropTypes.string,
        year: PropTypes.number,
        inseeTotal: PropTypes.number,
        inseeTotalAuto: PropTypes.bool,
        temporaryResident: PropTypes.number,
        temporaryResidentAuto: PropTypes.bool,
        increasedTotal: PropTypes.number,
        increasedTotalAuto: PropTypes.bool,
    }),
    setPopulations: PropTypes.func,
    defaultValue: PropTypes.shape({
        cityCode: PropTypes.string,
        year: PropTypes.number,
        inseeTotal: PropTypes.number,
        inseeTotalAuto: PropTypes.bool,
        temporaryResident: PropTypes.number,
        temporaryResidentAuto: PropTypes.bool,
        increasedTotal: PropTypes.number,
        increasedTotalAuto: PropTypes.bool,
    }),
    setDefaultValue: PropTypes.func,
    isNew: PropTypes.bool,
    setIsNew: PropTypes.func,
}

export default DialogPopulation